import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "@/config";
import Reveal from "@/components/Reveal";

export default function About() {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const y = useTransform(scrollYProgress, [0, 1], [-24, 24]);

    return (
        <section id="about" className="grid lg:grid-cols-2" data-testid="about-section">
            {/* Left — burgundy panel */}
            <div className="bg-burgundy text-cream px-6 sm:px-12 lg:px-20 py-20 lg:py-28 flex flex-col justify-center">
                <Reveal>
                    <div className="flex items-center gap-3 mb-5">
                        <span className="h-px w-10 bg-gold" />
                        <span className="text-[11px] font-semibold tracking-[0.34em] text-gold">ABOUT ANALYTROVA</span>
                    </div>
                    <h2 className="text-4xl sm:text-5xl leading-[1.12]">
                        Your Partner in Data,{" "}
                        <em className="italic text-gold">Creative</em> &amp; Digital Growth
                    </h2>
                </Reveal>
                <Reveal delay={0.1}>
                    <p className="mt-7 text-cream/80 leading-relaxed max-w-xl">
                        Analytrova is a modern solutions company offering data analytics, website design, branding and creative digital services.
                    </p>
                    <p className="mt-4 text-cream/80 leading-relaxed max-w-xl">
                        We combine technology, creativity and strategy to help businesses and individuals achieve their goals.
                    </p>
                    <a href="#about" className="btn btn-gold w-fit mt-9 group" data-testid="about-learn-more">
                        Learn More
                        <ArrowRight className="btn-arrow w-4 h-4" />
                    </a>
                </Reveal>
            </div>

            {/* Right — image with parallax */}
            <div ref={ref} className="relative min-h-[320px] sm:min-h-[420px] lg:min-h-0 overflow-hidden">
                <motion.img
                    style={{ y }}
                    src={IMAGES.about}
                    alt="Analytrova professional workspace"
                    className="absolute inset-0 w-full h-full object-cover scale-[1.15]"
                    data-testid="about-image"
                />
            </div>
        </section>
    );
}
